/**
 * Import CSS
 */
import './navigator.css';

/**
 * Import OL classes
 */
import {Control} from 'ol/control';
import {getCenter as getExtentCenter} from 'ol/extent';
import VectorLayer from 'ol/layer/Vector';

/**
 * Import global variables
 */
import {exhibitionConfig, lang, map} from '/main';
import {forEachElement, setHeight, sortObjects, createHTMLElement} from '/src/modules/misc/misc';
import {focusOn} from '/src/modules/features/featureControl';
import {showContext, terminateContext} from '/src/modules/Controls/context/context';
import {replaceTextPlaceholder} from '/src/modules/language/language';

export class NavigatorControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const navigatorContainer = createHTMLElement('div', 'navigatorContainer');
    const navigatorButton = createHTMLElement('div', null, 'navigatorButton');

    if (exhibitionConfig['menu']['display'] !== null && exhibitionConfig['menu']['display'] !== false) {
      navigatorButton.className = 'navigatorButton';
      navigatorButton.innerHTML = '<i class="fas fa-bars" id="buttonBars">';
    } else {
      navigatorButton.className = 'navigatorButtonForLogo';
      navigatorButton.innerHTML = '<i class="material-icons" id="flayrLogo">layers</i>';
    }

    const navigatorGuideText = createHTMLElement('div', 'navigatorGuideText');
    const navigatorGuideTextSpan = createHTMLElement('span', null, null, (exhibitionConfig['menu']['navigator']['jumpListText_' + lang['id']] !== null ? exhibitionConfig['menu']['navigator']['jumpListText_' + lang['id']] + ' ' : lang['navigatorYouAreHere']));
    navigatorGuideText.appendChild(navigatorGuideTextSpan);

    const selectBoxContainer = createHTMLElement('div', 'selectBoxContainer', 'selectBoxContainer');
    const navigatorSelect = createHTMLElement('select', 'navigatorSelect sources', 'sources');
    navigatorSelect.name = 'sources';
    navigatorSelect.setAttribute('placeholder', (exhibitionConfig['menu']['navigator']['placeholder_' + lang['id']] !== null ? exhibitionConfig['menu']['navigator']['placeholder_' + lang['id']] : lang['navigatorPlaceholder']));

    const selectOption = createHTMLElement('option', 'selection', null, (exhibitionConfig['menu']['navigator']['placeholder_' + lang['id']] !== null ? exhibitionConfig['menu']['navigator']['placeholder_' + lang['id']] : lang['navigatorPlaceholder']));
    selectOption.value = '0';
    selectOption.selected = true;

    navigatorSelect.appendChild(selectOption);
    selectBoxContainer.appendChild(navigatorSelect);
    navigatorContainer.appendChild(navigatorButton);
    navigatorContainer.appendChild(navigatorGuideText);
    navigatorContainer.appendChild(selectBoxContainer);

    super({
      element: navigatorContainer,
      target: options.target,
    });

    if (typeof exhibitionConfig['menu'] !== 'undefined' && exhibitionConfig['menu']['display'] !== false) {
      navigatorButton.addEventListener('click', () => {
        document.getElementById('overlayMenu').style.transform = 'translateX(360px)';
      }, {passive: true});
    }
  }
}

export function addNavigatorOptions(options) {
  let selectOptions = [];

  if (options.length > 0) {
    let featureId = 1;
    for (let i = 0; i < options.length; i++) {
      options[i].getSource().forEachFeature((feature) => {
        if (
          feature.get('type') === 'Halle'
          || feature.get('type') === 'Hof'
          || feature.get('type') === 'Eingang'
          || feature.get('type') === 'Freigelände'
          || feature.get('type') === 'Atrium'
          || feature.get('type') === 'ICM'
        ) {
          feature.getId() === undefined ? feature.setId(featureId) : null;
          featureId++;

          let featureTitle = replaceTextPlaceholder(feature.get('name'));

          let selectObjectTitle = '';

          if (feature.get('type') === 'Halle') {
            selectObjectTitle = lang['jsonHall'] + ' ' + featureTitle;
          } else if (feature.get('type') === 'Hof') {
            selectObjectTitle = lang['YARD'] + ' ' + featureTitle;
          } else if (feature.get('type') === 'Eingang') {
            selectObjectTitle = lang['jsonEntry'] + ' ' + featureTitle;
          } else {
            selectObjectTitle = featureTitle;
          }

          let selectObject = {
            'id': feature.getId(),
            'title': selectObjectTitle,
          };
          selectOptions.push(selectObject);
        }
      });
    }

    selectOptions.sort((a, b) => {
      return sortObjects(a.title, b.title);
    });

    for (let s = 0; s < selectOptions.length; s++) {
      let selectBoxOption = document.createElement('option');
      selectBoxOption.value = selectOptions[s].id;
      selectBoxOption.innerHTML = selectOptions[s].title;

      document.getElementById('sources').appendChild(selectBoxOption);
    }
  }
}

export function selectCenterFeature(activate) {
  if (activate === true) {
    if (map.hasFeatureAtPixel(map.getPixelFromCoordinate(map.getView().getCenter())) === true) {
      let feature = map.getFeaturesAtPixel(map.getPixelFromCoordinate(map.getView().getCenter()));

      for (let l = 0; l < feature.length; l++) {
        if (feature[l].getId() !== undefined) {
          let selectBox = document.getElementById('navigatorSelectOptions');
          let selectOptions = selectBox.getElementsByClassName('navigatorSelectOption');

          for (let so = 0; so < selectOptions.length; so++) {
            if (feature[l].getId() === selectOptions[so].getAttribute('data-value')) {
              document.getElementById('navigatorSelectTriggerText').innerHTML = selectOptions[so].innerHTML;

              for (let si = 0; si < selectOptions.length; si++) {
                if (selectOptions[si].classList.contains('selection')) {
                  selectOptions[si].classList.remove('selection');
                }
              }
              selectOptions[so].classList.add('selection');
            }
          }
        }
      }
    } else {
      let selectBox = document.getElementById('navigatorSelectOptions');
      let selectOptions = selectBox.getElementsByClassName('navigatorSelectOption');

      for (let so = 0; so < selectOptions.length; so++) {
        if (parseInt(selectOptions[so].getAttribute('data-value')) === 0) {
          document.getElementById('navigatorSelectTriggerText').innerHTML = selectOptions[so].innerHTML;

          for (let si = 0; si < selectOptions.length; si++) {
            if (selectOptions[si].classList.contains('selection')) {
              selectOptions[si].classList.remove('selection');
            }
          }
          selectOptions[so].classList.add('selection');
        }
      }
    }
  } else {
    if (map.hasFeatureAtPixel(map.getPixelFromCoordinate(map.getView().getCenter())) === true) {
      let selectBox = document.getElementById('navigatorSelectOptions');
      let selectOptions = selectBox.getElementsByClassName('navigatorSelectOption');

      for (let so = 0; so < selectOptions.length; so++) {
        if (parseInt(selectOptions[so].getAttribute('data-value')) === 0) {
          document.getElementById('navigatorSelectTriggerText').innerHTML = selectOptions[so].innerHTML;

          for (let si = 0; si < selectOptions.length; si++) {
            if (selectOptions[si].classList.contains('selection')) {
              selectOptions[si].classList.remove('selection');
            }
          }
          selectOptions[so].classList.add('selection');
        }
      }
    } else {
      let selectBox = document.getElementById('navigatorSelectOptions');
      let selectOptions = selectBox.getElementsByClassName('navigatorSelectOption');

      for (let so = 0; so < selectOptions.length; so++) {
        if (parseInt(selectOptions[so].getAttribute('data-value')) === 0) {
          document.getElementById('navigatorSelectTriggerText').innerHTML = selectOptions[so].innerHTML;

          for (let si = 0; si < selectOptions.length; si++) {
            if (selectOptions[si].classList.contains('selection')) {
              selectOptions[si].classList.remove('selection');
            }
          }
          selectOptions[so].classList.add('selection');
        }
      }
    }
  }
}

export function closeSideNavigation(event) {
  if (event.defaultPrevented) {
  } else {
    let menu = document.getElementById('overlayMenu');
    let main = document.getElementById('main');
    let subMenu = document.getElementsByClassName('sub');

    if (menu.style.transform === 'translateX(360px)') {
      menu.style.transform = '';
      for (let index in subMenu) {
        if (subMenu[index].style && subMenu[index].style.transform) {
          if (subMenu[index].style.transform === 'translateX(0px)') {
            main.style.transform = '';

            setTimeout(() => {
              subMenu[index].style.transform = '';
            }, 300);
          }
        }
      }
    }
  }
}

export function prettyNavigator() {
  let selectBox = document.getElementById('sources');

  let classes = selectBox.getAttribute('class');
  let template = '<div class="' + classes + '">';

  template += '<span class="navigatorSelectTrigger" id="navigatorSelectTrigger"><span class="navigatorSelectTriggerText" id="navigatorSelectTriggerText">' + selectBox.getAttribute('placeholder') + '</span></span>';
  template += '<div class="navigatorSelectOptions" id="navigatorSelectOptions" style="max-height: ' + setHeight(-100) + 'px" data-simplebar>';

  forEachElement('option', (option) => {
    if (option.getAttribute('class') !== null) {
      let selectOption = document.createElement('span');
      selectOption.className = 'navigatorSelectOption ' + option.getAttribute('class');
      selectOption.setAttribute('data-value', option.value);
      selectOption.innerHTML = option.innerHTML;

      selectOption.addEventListener('mouseover', () => {
        selectOption.classList.add('optionHover');
      }, {passive: true});

      selectOption.addEventListener('mouseout', () => {
        selectOption.classList.remove('optionHover');
      }, {passive: true});

      template += '<span class="navigatorSelectOption ' + option.getAttribute('class') + '" data-value="' + option.value + '">' + option.innerHTML + '</span>';
    } else {
      template += '<span class="navigatorSelectOption" data-value="' + option.value + '">' + option.innerHTML + '</span>';
    }
  });

  template += '</div></div>';

  let wrapper = document.createElement('div');
  wrapper.className = 'navigatorSelectWrapper';
  wrapper.id = 'navigatorSelectWrapper';
  selectBox.parentNode.insertBefore(wrapper, selectBox);
  wrapper.appendChild(selectBox);

  let navigator = document.getElementById('selectBoxContainer');
  navigator.appendChild(wrapper);

  selectBox.style.display = 'none';
  selectBox.insertAdjacentHTML('afterend', template);

  $(document).ready(function() {
    $('.navigatorSelectOption:first-of-type').hover(function() {
      $(this).parents('.navigatorSelectOptions').addClass('optionHover');
    }, function() {
      $(this).parents('.navigatorSelectOptions').removeClass('optionHover');
    });

    $('.navigatorSelectTrigger').on('click', function(event) {
      $('html').one('click', function() {
        $('.navigatorSelect').removeClass('opened');
      });
      $(this).parents('.navigatorSelect').toggleClass('opened');
      event.stopPropagation();
    });

    $('.navigatorSelectOption').on('click', function() {
      $(this).parents('.navigatorSelectWrapper').find('select').val($(this).data('value'));
      $(this).parents('.navigatorSelectOptions').find('.navigatorSelectOption').removeClass('selection');
      $(this).addClass('selection');
      $(this).parents('.navigatorSelect').removeClass('opened');
      $(this).parents('.navigatorSelect').find('.navigatorSelectTriggerText').text($(this).text());

      let id = $(this).data('value');

      if (id === 0) {
        focusOn(map.getView().get('baseCenter'), 'base', map.getView().get('baseZoom'), null, true);
        terminateContext();
      }

      let layers = map.getLayers();

      layers.forEach(function(layer) {
        if (layer instanceof VectorLayer) {
          layer.getSource().forEachFeature(function(feature) {
            if (feature.getId() === id) {
              let featureExtent = feature.getGeometry().getExtent();
              let extentCenter = getExtentCenter(featureExtent);

              focusOn(extentCenter, feature.get('rotation'), feature.get('zoom'), featureExtent, true);

              if (typeof feature.get('contextObject') !== 'undefined') {
                showContext(feature);
              } else {
                terminateContext();
              }
            }
          });
        }
      });
    });
  });
}
